import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="payment-cancel">
      <XCircle size={48} className="text-muted-foreground" />
      <h1 className="mt-5 font-heading text-2xl font-bold">Checkout canceled</h1>
      <p className="mt-2 text-sm text-muted-foreground">No charge was made. You can pick a plan whenever you're ready.</p>
      <div className="mt-6 flex gap-3">
        <Button onClick={() => nav("/pricing")} className="bg-volt hover:bg-volt/90 rounded-sm">Back to Plans</Button>
        <Button variant="outline" onClick={() => nav("/")} className="rounded-sm border-border">Dashboard</Button>
      </div>
    </div>
  );
}
